// extracted by mini-css-extract-plugin
export default {"layoutBckImageSvg":"Layout_layoutBckImageSvg__qESWl","layoutBckImageContractorSvg":"Layout_layoutBckImageContractorSvg__IRvW3"};